export default __webpack_public_path__ + "static/demo-49f8e262a47eb7558929e7fa8938f3b6.jpg";